import React from 'react';
import CloseIcon from '@mui/icons-material/Close';


export const DoctorCheckup = (props) => {

    return (
        <div className="Modal">
            <div className="ModalBg">
                <div className="ModalContent Learn">
                    <header>
                        <h1 style={{ color: 'white' }}>Doctor Checkup</h1>
                    </header>
                    <section>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/bwx2Z69S0YA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </section>
                    <footer>
                        <a href="#" onClick={() => props.onClose()}><CloseIcon style={{ width: '80px', height: '80px', color: 'white' }} /></a>
                    </footer>

                </div>
            </div>
        </div>
    )
}

export const WantToBeDoctor = (props) =>  {
    return(
        <div className="Modal">
            <div className="ModalBg">
                <div className="ModalContent Learn">
                    <header>
                        <h1 style={{ color: 'white' }}>I Want To Be A Doctor</h1>
                    </header>
                    <section>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/JxdrEFz9Jsw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </section>
                    <footer>
                        <a href="#" onClick={() => props.onClose()}><CloseIcon style={{ width: '80px', height: '80px', color: 'white' }} /></a>
                    </footer>

                </div>
            </div>
        </div>
    )
}

export const DoctorsOffice = (props) => {
    return (
        <React.Fragment>
            <div className="Modal">
            <div className="ModalBg">
                <div className="ModalContent Learn">
                    <header>
                        <h1 style={{ color: 'white' }}>Doctor's Office</h1>
                    </header>
                    <section>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/gXXmVqS3tLk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </section>
                    <footer>
                        <a href="#" onClick={() => props.onClose()}><CloseIcon style={{ width: '80px', height: '80px', color: 'white' }} /></a>
                    </footer>

                </div>
            </div>
        </div>
        </React.Fragment>
    )
}
